import React, { useContext } from "react";
import { TiClipboard } from "react-icons/ti";
import { CiHeart } from "react-icons/ci";
import { GoGear } from "react-icons/go";
import { IoChevronForward } from "react-icons/io5";
import { AppContextProvider } from "../../App";
import { CgCreditCard } from "react-icons/cg";
export const AcSidebar = ({ setShowCurrentTab, currentColor, currentTab }) => {
  const { showMobileAccMenu } = useContext(AppContextProvider);
  return (
    <>
      <div className="hidden lg:block h-screen  dark:border-gray-800 ">
        <ul className="flex px-4 py-10 flex-col gap-8">
          <li
            onClick={() => setShowCurrentTab(1)}
            className={
              currentTab == 1
                ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between min-w-[220px]`
                : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
            }
          >
            <div className="flex items-center space-x-2">
              <TiClipboard className="text-2xl" />
              <p>My Orders</p>
            </div>
            <IoChevronForward
              className={currentTab == 1 ? "flex justify-end" : "hidden"}
            />
          </li>
          <li
            onClick={() => setShowCurrentTab(2)}
            className={
              currentTab == 2
                ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between min-w-[240px]`
                : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
            }
          >
            <div className="flex items-center space-x-2">
              <CiHeart className="text-2xl" />
              <p>Favourite Products</p>
            </div>
            <IoChevronForward
              className={currentTab == 2 ? "flex justify-end" : "hidden"}
            />
          </li>
          <li
            onClick={() => setShowCurrentTab(3)}
            className={
              currentTab == 3
                ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center justify-between space-x-2`
                : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
            }
          >
            <div className="flex items-center space-x-2">
              <CgCreditCard className="text-2xl" />
              <p>Billing Details</p>
            </div>
            <IoChevronForward
              className={currentTab == 3 ? "flex justify-end" : "hidden"}
            />
          </li>
          <li
            onClick={() => setShowCurrentTab(4)}
            className={
              currentTab == 4
                ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between`
                : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
            }
          >
            <div className="flex items-center space-x-2">
              <GoGear className="text-2xl" />
              <p>Account Settings</p>
            </div>
            <IoChevronForward
              className={currentTab == 4 ? "flex justify-end" : "hidden"}
            />
          </li>
          <li></li>
        </ul>
      </div>
    </>
  );
};
